import { readFile } from "@/helpers/cropImage";
import { useImageCropContext } from "@/providers/ImageCropProvider";
import WideButton from "@/components/common/WideButton";
import Cropper from "@/components/cropper/Cropper";
import { RotationSlider, ZoomSlider } from "@/components/cropper/Sliders.jsx";
import { useI18N } from "common/hooks";
import { useDarkMode } from "@/hooks/useDarkMode";
import { useEffect, useRef } from "react";
import { StandardButton } from "@/components/common/StandardButton";

const CoverPhotoCropModalContent = ({ handleDone, handleClose }) => {
  const { setImage } = useImageCropContext();
  const i18n = useI18N();
  const isDark = useDarkMode();

  const handleFileChange = async ({ target: { files } }) => {
    const file = files && files[0];
    const imageDataUrl = await readFile(file);
    setImage(imageDataUrl);
  };

  const firstFocusRef = useRef(null); // Reference for the element we need to set focus

  // Focus on the element when the component mounts
  useEffect(() => {
    if (firstFocusRef.current) {
      firstFocusRef.current.focus();
    }
  }, []);

  return (
    <div className="text-center relative">
      <div className="mb-5">
        <h1
          className="title-s-semibold text-center text-fg-neutral-strong"
          ref={firstFocusRef} // Attach the ref here
        >
          {i18n.get("updateCoverPhoto")}
        </h1>
      </div>

      <div className="border border-dashed border-gray-200 p-6 rounded-lg">
        <div className="flex justify-center">
          <div className="crop-container mb-4">
            <Cropper />
          </div>
        </div>
        <ZoomSlider className="mb-4" />
        <RotationSlider className="mb-4" />
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="hidden"
          id="avatarInput"
          accept="image/*"
        />

        <div className="cursor-pointer">
          <div className="flex justify-center body-l-semibold text-links underline">
            <label htmlFor="avatarInput" className="cursor-pointer">
              {i18n.get("chooseADifferentPhoto")}
            </label>
          </div>
        </div>

        <div className="flex gap-2 mt-4">
          <WideButton disabled={false} onClick={handleDone}>
            {i18n.get("save")}
          </WideButton>
        </div>
      </div>

      <StandardButton
        variant="closeModalZero"
        onClick={handleClose}
        imageSrc={isDark ? "/images/Close_dark.svg" : "/images/Close.svg"}
        imageAlt="Close"
        size="icon-xlg"
      />
    </div>
  );
};

export default CoverPhotoCropModalContent;
